import { render, staticRenderFns } from "./EditTags.vue?vue&type=template&id=fed8bf62&scoped=true"
import script from "./EditTags.vue?vue&type=script&lang=ts"
export * from "./EditTags.vue?vue&type=script&lang=ts"
import style0 from "./EditTags.vue?vue&type=style&index=0&id=fed8bf62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed8bf62",
  null
  
)

export default component.exports